import Link from '@mui/material/Link';
import { styled } from '@mui/material/styles';

const ThemedLink = styled(Link)(({ theme }) => ({
    '&:hover': {
        backgroundColor: 'transparent',
    },
    color: theme.palette.mode === 'dark' && theme.palette.contrastDefault.main
}));

export { ThemedLink };